import React from 'react'
import { Button } from '../../pages/home/components/HeroSession.js/HeroSession.styles';
import { FormContainer, InputContainer } from '../betaForm/BetaDetail'

const ChildrenDetail = () => {
  return (
    <FormContainer>
      <InputContainer>
        <div>
          <label>Where do you work currently?</label>
          <input placeholder="eg Coca Cola" />
        </div>
        <div>
          <label>Monthly Salary?</label>
          <input placeholder="eg 500,000" />
        </div>
        <div>
          <label>Number of Children</label>
          <input placeholder="eg, 2 children" />
        </div>
        <div>
          <label>Current age of your child(ren)</label>
          <input placeholder="eg 10 years and 8 years respectively" />
        </div>
        <div>
          <label>
            Are you saving for Primary, Secondary or University education?
          </label>
          <input placeholder="eg, secondary school education" />
        </div>
        <div>
          <label>Will your child(ren) be studying
in Nigeria or abroad?</label>
          <input placeholder="eg, Nigeria" />
        </div>
      </InputContainer>
      <div className="submit__button">
        <Button
          style={{ color: "#fff", fontSize: "16px", marginTop: "20px" }}
          to="/contact"
        >
          Finish
        </Button>
      </div>
    </FormContainer>
  );
}

export default ChildrenDetail